import React from "react";

export default function ComingSoon() {
  return (
    <div className="bg-white rounded-lg shadow-md w-full max-w-xl p-8flex items-center justify-center p-4">
      {/* Highlight box */}
      <div className="bg-green-100 text-green-800 font-semibold rounded px-4 py-2 mb-6 text-center">Feature in Progress</div>

      {/* Description */}
      <div className="text-center">
        <h3 className="text-xl font-bold text-green-700 mb-2">We're Building Something Great!</h3>
        <p className="text-gray-700 mb-6">This section is under development. Stay tuned as we finalize and launch exciting new features.</p>

        {/* Optional action */}
        <button className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded transition" disabled>
          Coming Soon
        </button>
      </div>
    </div>
  );
}
